import { apiConstructor as api } from '@/api/apiConstructor';
import { Image, ImageMonth } from '@/types/image';
import { PaginatedImagesResult } from '@/types/image';
import { Tag } from '@/types/tag';
import { AxiosRequestConfig, AxiosResponse } from 'axios';

export async function getImageMonths(): Promise<ImageMonth[]> {
  const response: AxiosResponse = await api.get('images/available-months');
  return response.data;
}

export async function getImagesPage(
  page: number = 1,
  filters: {
    monthStarting: string;
  },
): Promise<PaginatedImagesResult> {
  const config: AxiosRequestConfig = {
    params: {
      page,
      ...filters,
    },
  };

  try {
    const response: AxiosResponse = await api.get('images', config);
    return response.data;
  } catch (error: any) {
    return error.data;
  }
}

export async function getSuggestedTags(id: string): Promise<string[]> {
  try {
    const response: AxiosResponse = await api.get(
      `images/${id}/suggested-tags`,
    );
    return response.data;
  } catch (error: any) {
    return [];
  }
}

export async function uploadImage(file: File): Promise<Image> {
  const config: object = {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  };

  const formData = new FormData();
  formData.append('image', file);

  const response: AxiosResponse = await api.post('images', formData, config);
  return response.data;
}

export async function deleteImage(id: string) {
  await api.delete(`images/${id}`);
}

export async function updateImageTags(
  id: string,
  tags: string[],
): Promise<Tag[]> {
  const response: AxiosResponse = await api.post(`images/${id}/tags`, { tags });
  return response.data;
}
